import { MonthlyReportUIProvider } from "./MonthlyReportUIContext";
import { MonthlyReportCard } from "./MonthlyReportCard";

export function MonthlyReportPage({
  term,
  date,
  dateEnd,
  sectionId,
  studentId
}) {  
  return (
    <MonthlyReportUIProvider monthlyReportParameters={{ term, date, dateEnd, sectionId, studentId }}>
      <MonthlyReportCard />
    </MonthlyReportUIProvider>
 );
}